import React from 'react'

import imgDevelopment from './../../../img/development_document.svg'
import Empty from '../../_ui/empty'
import css from './ratings.module.scss'

const Ratings = (props: any) => {
    return (
        <div className={css.main}>
            <Empty image={imgDevelopment} description="Раздел находится в разработке" />
        </div>
    )
}

export default Ratings